import React from 'react';
import createModal from 'modules/modal';
import { CustomDigitalGiftCardActionModel } from 'autogen/swagger/all';
import { CustomMouseEvent } from 'shared/interfaces/events';
import fetch from 'cross-fetch';
import CustomGiftCard from './customGiftCard';

export default async function customizeProduct(event: CustomMouseEvent): Promise<void> {
    const { delegateTarget } = event;
    const {
        dataset: { jsCustomizeProductUrl }
    } = delegateTarget;

    const dataPromise = fetch(jsCustomizeProductUrl);
    const modal = createModal();
    const data: CustomDigitalGiftCardActionModel = await dataPromise.then((res) => res.json());

    modal({ open: true, content: <CustomGiftCard {...data} /> });
}
